import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TrinityComponent } from './trinity.component';
import { TrinityListComponent } from './trinity-list/trinity-list.component';
import { TrinityRequestComponent } from './trinity-request/trinity-request.component';

const routes: Routes = [{
  path:'',
  component:TrinityComponent,
  children:[
    {path:'',component:TrinityListComponent},
    // {path:'request',component:TrinityListComponent},
    {path:'request',component:TrinityRequestComponent},
    {path:'request/:uuid',component:TrinityRequestComponent},
  ]
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TrinityRoutingModule { }
